import { render } from "./SetRating.vue?vue&type=template&id=dfe82080"
import script from "./SetRating.vue?vue&type=script&lang=js"
export * from "./SetRating.vue?vue&type=script&lang=js"

import "./SetRating.vue?vue&type=style&index=0&id=dfe82080&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__